import { Col, Container, Row } from "reactstrap";
import Chip from "src/components/Common/UI/Chips/Chip";
import LinesAndNodesHeader from "./LinesAndNodesHeaders";
import Lines from "./Lines/Lines";



const LineConfiguration = () =>{
  
    const chipHeaders = [""];
    const chipItems: React.ReactNode[] = [
      <Lines />,
      
      
    ];
  
    return (
      <div className="page-content">
        <LinesAndNodesHeader />
  
        <Container fluid>
          <Row>
            <Col xs={12}>
              {<Chip
                tabNavHeaderItems={chipHeaders}
                tabContentItems={chipItems}
                hasStatusCircle={false}
              />}
            </Col>
          </Row>
        </Container>
  
  
      </div>
    );
}

export default LineConfiguration